var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"topbar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"topbar__block"},[_c('TopbarLocation',{staticClass:"topbar__select"}),_vm._v(" "),_c('TopbarLanguage',{staticClass:"topbar__select"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }